module.exports = __webpack_public_path__ + "../resources/img/Icon_Arrow_Right.b86bbf30.svg";